import { module } from 'modujs';

/**
 * Component for downloading a flight schedule
 */
export default class extends module {
    init() {
        this.form   = this.$('form')[0];
        this.select = this.$('select')[0];

        this.onSubmitBind = this.onSubmit.bind(this);

        if (this.form && this.select) {
            this.form.addEventListener('submit', this.onSubmitBind);
        } else {
            console.warn('[App.ScheduleDownloader] No schedule form or select list found.');
        }
    }

    onSubmit(event) {
        event.preventDefault();
        event.stopPropagation();

        if (this.select.value) {
            window.open(this.select.value);
        } else {
            console.error('[App.ScheduleDownloader] No schedule selected.');
        }
    }

    destroy() {
        super.destroy();

        if (this.form) {
            this.form.removeEventListener('submit', this.onSubmitBind);
        }
    }
}
